import React from "react";
import { teamMeta } from "../lib/teamMeta";

/**
 * Small color-coded badge with the club's 3-letter abbreviation.
 * Pass `team` (full name as stored on the user). Renders nothing if unknown.
 */
export const TeamBadge = ({ team, size = "sm" }) => {
  const meta = teamMeta(team);
  if (!meta) return null;
  const dims = size === "lg"
    ? "px-2 py-1 text-[11px]"
    : "px-1.5 py-0.5 text-[9px]";
  return (
    <span
      data-testid={`team-badge-${meta.abbr}`}
      title={team}
      aria-label={`Supports ${team}`}
      className={`inline-flex items-center justify-center font-mono-num font-black tracking-wider uppercase rounded-sm leading-none ${dims}`}
      style={{
        backgroundColor: meta.color,
        color: meta.text,
        border: "1px solid rgba(255,255,255,0.15)",
      }}
    >
      {meta.abbr}
    </span>
  );
};

export default TeamBadge;
